import firebase from "firebase";
import "firebase/firestore";

// firebase init goes here
const config = 
{
    apiKey: "AIzaSyBaZGOLWwrGFk6X391FuVZfJ6zbZeO8psI",
    authDomain: "jessica-and-krystal.firebaseapp.com",
    databaseURL: "https://jessica-and-krystal.firebaseio.com",
    projectId: "jessica-and-krystal",
    storageBucket: "jessica-and-krystal.appspot.com",
    messagingSenderId: "1083807983310",
    appId: "1:1083807983310:web:af1edb0148bb2893f5929f",
    measurementId: "G-YE1979LJB6"
}

try{
	firebase.initializeApp(config);
}
catch(err) {
	console.log(err);
}

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const currentUser = auth.currentUser;
const settings = 
{
    
}
db.settings(settings);

// firebase collections
const usersCollection = db.collection('users');
const threadsCollection = db.collection('threads');
const commentsCollection = db.collection('comments');
const likesCollection = db.collection('likes');

export {
    db,
    auth,
    currentUser,
    usersCollection,
    threadsCollection,
    commentsCollection,
    likesCollection
}
